//react
import { useEffect, useState } from "react";

//Libs
import { datadogLogs } from "@datadog/browser-logs";
import toast, { Toaster } from "react-hot-toast";

//Components
import CaptureSelfie from "../AcuantCamaraResult/CaptureSelfie.js";

//redux
import { store } from "../../lib/store.js";
import { getInstance } from "../../lib/slices/assure.js";
import { scanFacematch } from "../../lib/slices/paladin.js";

//Hooks
import RoundLoader from "../../Hooks/RoudLoader.js";

//constants
import {
    ALERTS_STYLES,
    ALERTS_POSITION_SELFIE,
} from "../../constants/alerts.js";

const SelfieOnly = ({ responseScan, tenantColor, tenantImage, tenantName }) => {
    const [instance, setInstance] = useState();
    const { dispatch } = store;
    const [loading, setLoading] = useState(false);

    const queryInstance = async (responseScan) => {
        try {
            setLoading(true);
            var data = { responseScan };

            const instance = await dispatch(
                getInstance({
                    data,
                })
            );
            if (!instance?.error) {
                setInstance(instance?.payload?.instance);

                datadogLogs.logger.info(
                    `Instance set (SelfieOnly) with the invitationId: ${responseScan?.invitation_id}`,
                    {
                        invitationId: responseScan?.invitation_id,
                        instance: instance,
                    }
                );
            } else {
                toast.error(
                    "Error to try to get the instance, please try again later."
                );
                datadogLogs.logger.error(
                    `Error loading Acuant Instance (SelfieOnly) with the invitationId: ${responseScan?.invitation_id}`,
                    {
                        invitationId: responseScan?.invitation_id,
                        error: instance,
                        message: "Error loading Acuant Instance",
                    }
                );
            }
        } catch (error) {
            toast.error("Error to try to get the instance, please try again later.");
            datadogLogs.logger.error(
                `Error processing instance (SelfieOnly) with the invitationId: ${responseScan?.invitation_id}`,
                {
                    invitationId: responseScan?.invitation_id,
                    message: "Error processing instance",
                    error: error,
                }
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (responseScan !== undefined && responseScan !== null) {
            queryInstance(responseScan);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseScan]);

    return (
        <>
            <section className="container p-2 w-full">
                {loading ? (
                    <section className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                        <RoundLoader
                            loading={true}
                            color={tenantColor}
                            responseScan={responseScan}
                            tenantImage={tenantImage}
                            tenantName={tenantName}
                        />
                    </section>
                ) : (
                    <CaptureSelfie
                        instance={instance}
                        responseScan={responseScan}
                        tenantColor={tenantColor}
                        tenantImage={tenantImage}
                        tenantName={tenantName}
                        submitAction={scanFacematch}
                    />
                )}
            </section>

            <Toaster
                position={ALERTS_POSITION_SELFIE}
                reverseOrder={false}
                toastOptions={ALERTS_STYLES}
            />
        </>
    );
};

export default SelfieOnly;
